import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";

function ProjectIntroSection() {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        overflow: "hidden",
        py: { xs: 6, md: 10 },
        background: `linear-gradient(135deg,
          #063d1f 0%,
          #0b5a2a 42%,
          #032414 100%)`,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: 460,
          height: 460,
          border: "3px solid rgba(255,255,255,0.10)",
          borderRadius: "50%",
          top: "-160px",
          left: "-160px",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: 300,
          height: 300,
          border: "2px solid rgba(255,255,255,0.14)",
          borderRadius: "50%",
          bottom: "-100px",
          right: "-80px",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: 640,
          height: 640,
          border: "2px dashed rgba(255,255,255,0.08)",
          borderRadius: "50%",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at 18% 25%, rgba(255,255,255,0.12), transparent 36%), radial-gradient(circle at 82% 72%, rgba(255,255,255,0.08), transparent 42%)",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          opacity: 0.08,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,.7) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.7) 1px, transparent 1px)",
          backgroundSize: "54px 54px",
        }}
      />

      <Container maxWidth="md" sx={{ position: "relative", zIndex: 2 }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <Box
            sx={{
              px: { xs: 3, md: 5 },
              py: { xs: 4, md: 5 },
              borderRadius: { xs: "22px", md: "30px" },
              backgroundColor: "rgba(255,255,255,0.10)",
              border: "1px solid rgba(255,255,255,0.22)",
              boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
              backdropFilter: "blur(8px)",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "0.82rem", md: "0.9rem" },
                fontWeight: 800,
                letterSpacing: "0.16em",
                textTransform: "uppercase",
                color: "rgba(255,255,255,0.82)",
                mb: 2,
              }}
            >
              Liga Deportiva Cantonal Mejía
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "1.65rem", md: "2.35rem" },
                lineHeight: 1.15,
                fontWeight: 900,
                color: "#fff",
                mb: 3,
              }}
            >
              Fútbol, competencia y pasión por Mejía
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "1.05rem", md: "1.2rem" },
                lineHeight: 1.85,
                color: "rgba(255,255,255,0.92)",
              }}
            >
              En la{" "}
              <Box component="span" sx={{ fontWeight: 800, color: "#ffffff" }}>
                Liga Deportiva Cantonal Mejía
              </Box>{" "}
              impulsamos el fútbol como un espacio de encuentro, disciplina y
              crecimiento deportivo. Cada partido representa la pasión de los
              equipos, el esfuerzo de los jugadores y el compromiso de nuestra
              comunidad con el deporte.
              <br />
            </Typography>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
}

export default ProjectIntroSection;